import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CustomBudgetBreakdown" }
const _hoisted_2 = { class: "CustomBudgetBreakdownCellValue" }
const _hoisted_3 = { class: "CustomBudgetBreakdownCellValue" }
const _hoisted_4 = { class: "CustomBudgetBreakdownCellValue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			'CustomBudgetBreakdownWrapper'
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("th", { class: "CustomBudgetBreakdownCellHeader" }, "Custom products budget", -1 /* CACHED */)),
            _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.budgetCustom), 1 /* TEXT */)
          ]),
          _createElementVNode("tr", {
            class: _normalizeClass({ 'CustomBudgetModified': _ctx.wereCustomProductsModified })
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("th", { class: "CustomBudgetBreakdownCellHeader" }, "Used for added products", -1 /* CACHED */)),
            _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.budgetUsed), 1 /* TEXT */)
          ], 2 /* CLASS */),
          _createElementVNode("tr", {
            class: _normalizeClass([
					'CustomBudgetBreakdownResultRow',
					{ 'CustomBudgetModified': _ctx.wereCustomProductsModified }
				])
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("th", { class: "CustomBudgetBreakdownCellHeader" }, "Budget left", -1 /* CACHED */)),
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.budgetLeft), 1 /* TEXT */)
          ], 2 /* CLASS */)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isLoading"]))
}